import React, { Fragment } from 'react'
import { connect } from 'redaction'

import Text from 'components/_new/typography/Text/Text'

import SubscriptionTitle from 'components/cart/SubscriptionTitle/SubscriptionTitle'
import Subscription from 'components/cart/Subscription/Subscription'
import ProductsTitle from 'components/cart/ProductsTitle/ProductsTitle'
import Products from 'components/cart/Products/Products'
import Section from 'components/cart/Section/Section'

import messages from './messages'
import s from './Content.scss'


const CartSidebarContent = ({ isSubscriptionExist, areProductsExist }) => (
  <div className={s.flexContainer}>
    <div className={s.content}>
      {
        isSubscriptionExist && (
          <Fragment>
            {
              isSubscriptionExist && areProductsExist && (
                <SubscriptionTitle />
              )
            }
            <Subscription />
          </Fragment>
        )
      }
      {
        areProductsExist && (
          <Section>
            {
              isSubscriptionExist && areProductsExist && (
                <ProductsTitle />
              )
            }
            <Products />
          </Section>
        )
      }
      {
        !isSubscriptionExist && !areProductsExist && (
          <Text
            className={s.empty}
            message={messages.emptyCart}
            size="14-24"
            align="center"
            uppercase
          />
        )
      }
    </div>
  </div>
)


export default connect({
  isSubscriptionExist: 'models.cart.isSubscriptionExist',
  areProductsExist: 'models.cart.areProductsExist',
})(CartSidebarContent)
